export const REGION = {
  MY: 'MY',
  SG: 'SG',
  HK: 'HK',
  CN: 'CN',
};

export const LANGUAGE = {
  EN: 'en-us',
  TC: 'zh-hk',
  SC: "zh-cn"
};